/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { Utils } from 'Utils/utils';
import { MX_EVENTS_AE, SALESGEAR_URL } from 'Utils/constants';
import salesgearLogo from 'Assets/logo/salesgear/sg32.png';
import ConnectEmailPng from 'Assets/salesgear/png/aeAddEmailAccount.png';
import BgDottedImg from 'Assets/salesgear/png/bgDotted.png';

const SalesgearConnectInbox = props => {
  const { hide } = props;

  const closePopup = () => {
    hide(false);
  };

  const redirectToAeConnectInbox = () => {
    hide(false);
    Utils.mixpanelTrack(MX_EVENTS_AE.addEmailAccountClicked);
    window.open(`${SALESGEAR_URL}/settings/account`);
  };

  useEffect(() => {
    Utils.mixpanelTrack(MX_EVENTS_AE.addEmailAccountShown);
  }, []);

  return (
    <>
      <div className="overlayMask" />
      <div className="salesgearBannerPopup ConnectInboxSection">
        <div className="aeCard popupAnimate popupScaleIn">
          <div className="aeTitle">
            <i className="material-icons closePopup" onClick={closePopup}>
              close
            </i>
            <h4 className="aeProductName">
              <img src={salesgearLogo} alt="" />
              <span className="text">Salesgear</span>
            </h4>
            <h4>Add your email account</h4>
          </div>
          <div className="aeBody aeUpgradeBody">
            <p className="aeDesc">
              Before adding contacts to sequences, you must add your email
              account with Salesgear.
            </p>
            <div className="btnSection aeBtnSection btm-95">
              <button
                className="btnSalesgear wiggle aeAddAccount"
                onClick={redirectToAeConnectInbox}
                type="button"
              >
                Add Email Account
              </button>
            </div>
            <img src={ConnectEmailPng} className="connectImg" alt="" />
            <img src={BgDottedImg} className="bgDotted" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesgearConnectInbox;
